@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

@toggle-height: 14px;
@toggle-knob-diameter: @toggle-height + 2px;

.checkbox-slider {
  display: inline-block;
  font-size: 0;
  vertical-align: top;

  .checkbox-slider-text {
    font-size: 14px;
    color: @checkbox-slider--label--text-color;
    pointer-events: none;
  }

  input[type='checkbox'] {
    opacity: 0;
    display: none;

    &:checked {
      + label > .slider {
        &:after {
          margin-left: @toggle-knob-diameter;
          background: @checkbox-slider--checked--after--background-color;
        }

        &:before {
          border: 1px solid @checkbox-slider--checked--before--border-color;
          background: @checkbox-slider--checked--before--background-color;
        }
      }
    }

    &:disabled {
      + label > .slider {
        color: @checkbox-slider--disabled--text-color;
        opacity: 0.75;
        cursor: default;

        &:after {
          background: @checkbox-slider--disabled--after--background-color;
        }

        &:before {
          background: @checkbox-slider--disabled--before--background-color;
        }
      }
    }
  }

  label {
    cursor: default;
    display: flex;
    align-items: center;
    transition: all ease 200ms;
    pointer-events: none;
    gap: @space-8;

    .slider {
      display: flex;
      position: relative;
      cursor: pointer;
      pointer-events: auto;

      &:before,
      &:after {
        content: '';
        display: inline-block;
        vertical-align: top;
        transition: all ease 200ms;
      }

      &:before {
        height: @toggle-height;
        width: calc(@toggle-height * 2);
        background: @checkbox-slider--label--before--background-color;
        border: 1px solid @checkbox-slider--label--before--border-color;
        border-radius: calc(@toggle-height / 2);
      }

      &:after {
        position: absolute;
        width: @toggle-knob-diameter;
        height: @toggle-knob-diameter;
        left: -1px;
        top: -1px;
        background: @checkbox-slider--label--after--background-color;
        border: 1px solid @checkbox-slider--label--after--border-color;
        border-radius: calc(@toggle-knob-diameter / 2);
        text-align: center;
      }
    }
  }
}
